import React from 'react';
import { PageHeader } from './PageHeader';
import { useTranslation } from '../i18n';
import './SettingsPage.css';

export const AboutPage: React.FC = () => {
  const t = useTranslation();

  return (
    <div className="page-container settings-page">
      <PageHeader title={t.about.title} />

      <div className="settings-content">
        <div className="about-hero">
          <div className="about-logo">🧠</div>
          <h2 className="about-app-name">Calmaro</h2>
          <p className="about-version">{t.about.version} 1.0.0</p>
        </div>

        <div className="settings-group">
          <h2 className="settings-group-title">{t.about.aboutCalmaro}</h2>
          <p className="about-description">
            {t.about.aboutDescription}
          </p>
        </div>

        <div className="settings-group">
          <h2 className="settings-group-title">{t.about.ourMission}</h2>
          <p className="about-description">
            {t.about.missionDescription}
          </p>
        </div>

        <div className="settings-group">
          <h2 className="settings-group-title">{t.about.information}</h2>
          <div className="info-list">
            <div className="info-item">
              <span className="info-label">{t.about.developer}</span>
              <span className="info-value">Calmaro Team</span>
            </div>
            <div className="info-item">
              <span className="info-label">{t.about.releaseDate}</span>
              <span className="info-value">November 2025</span>
            </div>
            <div className="info-item">
              <span className="info-label">{t.about.category}</span>
              <span className="info-value">{t.about.healthFitness}</span>
            </div>
          </div>
        </div>

        <div className="settings-group">
          <h2 className="settings-group-title">{t.about.legalInfo}</h2>
          <div className="legal-links">
            <a href="#" className="legal-link">{t.about.termsOfService}</a>
            <a href="#" className="legal-link">{t.about.privacyPolicy}</a>
            <a href="#" className="legal-link">{t.about.licenseAgreement}</a>
          </div>
        </div>

        <div className="about-footer">
          <p className="about-copyright">{t.about.copyright}</p>
        </div>
      </div>
    </div>
  );
};
